import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Collapse,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useCart } from "../../hooks/shareContext";
import OpenInFullOutlinedIcon from "@mui/icons-material/OpenInFullOutlined";
import CloseFullscreenOutlinedIcon from "@mui/icons-material/CloseFullscreenOutlined";
import summarize from "./../../assets/report-svgrepo-com.png"
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

// Icons
const homeIcon = VISUALIZE__URL + "home.svg";
const shareIcon = VISUALIZE__URL + "share.svg";
const loopIcon = VISUALIZE__URL + "loop.svg";
const reportIcon = VISUALIZE__URL + "reports.svg";
const settingsIcon = VISUALIZE__URL + "setting.svg";
const accountIcon = VISUALIZE__URL + "userSetting.svg";
const favoriteIcon = VISUALIZE__URL + "favorites.svg";
const myVideosIcon = VISUALIZE__URL + "my-videos-icon.png";
const summarizeIcon = summarize;
import { useTranslation } from "react-i18next";
import { Book } from "@mui/icons-material";
interface SidebarProps {
  open: boolean;
  toggleSidebar: () => void;
}

// const getUserId = localStorage.getItem("userId")
// console.log("get user id", JSON.parse(getUserId ?? null))
// const userId = [117, 118, 120, 122].includes(getUserId ? JSON.parse(getUserId) : 0)
// console.log("ans", userId)
// Add menu id

const menuItems = [
  {
    name: "home",
    icon: <img src={homeIcon} alt="Home" width={24} height={24} />,
    path: "/home",
    menuId: 1,
  },
  {
    name: "favorites",
    icon: <img src={favoriteIcon} alt="Favorites" width={24} height={24} />,
    path: "/favorites",
    menuId: 2,
  },
  {
    name: "My Videos",
    icon: <img src={myVideosIcon} alt="Favorites" width={24} height={24} />,
    path: "/my-videos",
    menuId: 8,
  },
  {
    name: "share_animation",
    icon: <img src={shareIcon} alt="share_animation" width={24} height={24} />,
    path: "/share-animation",
    menuId: 3,
  },
  {
    name: "animation_loop",
    icon: <img src={loopIcon} alt="animation_loop" width={24} height={24} />,
    subItems: [
      { name: "play_loop", path: "/loopvideo" },
      { name: "animation_loop_settings", path: "/animationloop/loop-setting" },
    ],
    menuId: 4,
  },
  {
    name: "reports",
    icon: <img src={reportIcon} alt="reports" width={24} height={24} />,
    subItems: [
      { name: "usage_reports", path: "/usageReports" },
      {
        name: "shared_animation_report",
        path: "/shared-animation-report",
      },
    ],
    menuId: 5,
  },
  {
    name: "manage_accounts",
    icon: (
      <img src={accountIcon} alt="manage_accounts" width={24} height={24} />
    ),
    subItems: [
      { name: "manage_locations", path: "/settings/manage-locations" },
      {
        name: "manage_locations_class",
        path: "/settings/manage-locations-class",
      },
      { name: "manage_users", path: "/settings/manage-users" },
      { name: "manage_subscriptions", path: "/settings/manage-subscriptions" },
    ],
    menuId: 6,
  },
  {
    name: "settings",
    icon: <img src={settingsIcon} alt="settings" width={24} height={24} />,
    subItems: [
      { name: "profile_settings", path: "/profile-setting" },
      { name: "manage_favorites", path: "/manage-favorites" },
      { name: "manage_categories", path: "/manage-categories" },
      {
        name: "share_animation_settings",
        path: "/email-setting",
      },
    ],
    menuId: 7,
  },
  {
    name: "Total User's Report",
    icon: <img src={summarizeIcon} alt="settings" width={24} height={24} />,
    path: "/total-users-report",
    menuId: 8,
  },
  {
    name: "User Guide",
    icon: <Book sx={{ width: 24, height: 24 }} />,
    path: "/user-guide",
    menuId: 9,
  }
];

const Sidebar: React.FC<SidebarProps> = ({ open, toggleSidebar }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:820px)");
  const { cartCount } = useCart();
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
  const [isBouncing, setIsBouncing] = useState(false);
  const [filteredMenuItems, setFilteredMenuItems] = useState(menuItems);
  const location = useLocation();

  const [activeItem, setActiveItem] = useState<{
    menuItem: string;
    subItem?: string;
  }>(() => {
    try {
      const savedItem = sessionStorage.getItem("activeMenu");
      return savedItem
        ? JSON.parse(savedItem)
        : { menuItem: "home", subItem: "" };
    } catch (error) {
      console.error("Error parsing sessionStorage data:", error);
      return { menuItem: "home", subItem: "" }; // Default if parsing fails
    }
  });

  useEffect(() => {
    sessionStorage.setItem("activeMenu", JSON.stringify(activeItem)); // Store both parent and sub-item
  }, [activeItem]);

  // logout home will be highlighted
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "logoutEvent") {
        sessionStorage.removeItem("activeMenu");
        setActiveItem({ menuItem: "home", subItem: "" });
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setIsBouncing(true);
    } else {
      setIsBouncing(false);
    }
  }, []);

  const userViewType = Number(localStorage.getItem("viewType"));

  useEffect(() => {
    // Filter menu items based on the menuId for the current viewType
    const filterItems = (viewType: number) => {
      if (viewType) {
        return menuItems; // Show all items (1 to 6)
      } else {
        // Show items with menuId between 1 and 2
        return menuItems.filter(
          (item) => item.menuId === 1 || item.menuId === 3
        );
      }
    };
    const filteredItems = filterItems(userViewType);
    setFilteredMenuItems(filteredItems);
  }, [userViewType]);

  useEffect(() => {
    setIsBouncing(true);
    const timeout = setTimeout(() => {
      setIsBouncing(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, [cartCount]);

  useEffect(() => {
    if (!open) {
      setOpenMenus({});
    }
  }, [open]);

  const toggleSubMenu = (menu: string) => {
    setOpenMenus((prev) => {
      // If the menu clicked is already open, close it
      if (prev[menu]) {
        return { ...prev, [menu]: false };
      }

      // Close all other menus and open only the clicked one
      return { [menu]: true };
    });

    if (!open) {
      toggleSidebar();
    }
  };

  const handleMenuClick = (item: string, subItem?: string) => {
    setActiveItem({ menuItem: item, subItem }); // Corrected variable name

    const selectedItem = menuItems.find((menuItem) => menuItem.name === item);
    // On mobile, picking any page (top-level or sub-item) closes the drawer
    if (isMobile && (subItem || !selectedItem?.subItems)) {
      toggleSidebar();
      return;
    }
    if (!selectedItem?.subItems) {
      if (isMobile) {
        toggleSidebar();
      } else {
        setIsBouncing(false);
      }
    } else {
      setOpenMenus((prev) => ({ ...prev, [item]: true }));
    }
  };

  // page redirects to the current location path
  useEffect(() => {
    // Find the main menu item that matches the current path
    const matchedMenuItem = menuItems.find(
      (item) =>
        item.path
          ? item.path === location.pathname // Match direct paths
          : item.subItems?.some((sub) => sub.path === location.pathname) // Check sub-items
    );

    if (matchedMenuItem) {
      // Find if the path belongs to a sub-item
      const matchedSubItem = matchedMenuItem.subItems?.find(
        (sub) => sub.path === location.pathname
      );

      // Update active state based on the current route
      setActiveItem({
        menuItem: matchedMenuItem.name,
        subItem: matchedSubItem?.name || "",
      });

      // Store in session storage
      sessionStorage.setItem(
        "activeMenu",
        JSON.stringify({
          menuItem: matchedMenuItem.name,
          subItem: matchedSubItem?.name || "",
        })
      );
    }
  }, [location.pathname]); // Runs when the URL changes

  return (
    <Drawer
      anchor="left"
      open={isMobile ? open : true}
      className="drawer_sec"
      onClose={toggleSidebar}
      variant={isMobile ? "temporary" : "persistent"}
      BackdropProps={{ invisible: true }}
      sx={{
        width: open ? 0 : 60,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: isMobile ? 260 : open ? 260 : 60,
          transition: "transform 0.4s ease-in-out, width 0.4s ease-in-out", // Smooth animations
          top: isMobile ? "67px" : "83px",
          height: "calc(100% - 61px)",
          backgroundColor: "#1976d2",
          visibility: "visible",
          boxShadow: isMobile ? "2px 0 8px rgba(0,0,0,0.15)" : "none",
          overflowX: "hidden",
          zIndex: isMobile ? 1200 : open ? 1200 : "auto",
        },
      }}>
      <List sx={{ paddingTop: "20px" }}>
        {!isMobile && (
          <ListItemButton
            sx={{ padding: 0, marginRight: "10px", justifyContent: "flex-end" }}
            onClick={toggleSidebar}>
            <ListItemIcon
              sx={{
                backgroundColor: "#004283",
                padding: "10px",
                borderRadius: "30px",
                color: "white",
                minWidth: "40px",
                border: "1px solid #ffffff",
                marginLeft: "10px",
                marginBottom: "10px",
                paddingRight: "10px",
              }}>
              {open ? (
                <CloseFullscreenOutlinedIcon sx={{ fontSize: "20px" }} />
              ) : (
                <OpenInFullOutlinedIcon sx={{ fontSize: "20px" }} />
              )}
            </ListItemIcon>
          </ListItemButton>
        )}
        {filteredMenuItems.map((item, index) => (
          <React.Fragment key={index}>
            <Tooltip
              title={!open && !isMobile ? t(item.name) : ""}
              placement="right"
              arrow
              PopperProps={{
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, -6],
                    },
                  },
                ],
              }}>
              <ListItemButton
                className={`sidebar-item ${item.name === "Animation Loop" ? "animation_loop_settings" : ""}`}
                onClick={() =>
                  item.subItems
                    ? toggleSubMenu(item.name)
                    : handleMenuClick(item.name)
                }
                sx={{
                  backgroundColor:
                    activeItem.menuItem === item.name
                      ? "#004283"
                      : "transparent",
                  borderTopRightRadius: "20px",
                  borderBottomRightRadius: "20px",
                  "&:hover": {
                    backgroundColor:
                      activeItem.menuItem === item.name ||
                        activeItem.subItem === item.name
                        ? "#004283"
                        : "#1565c0",
                  },
                  "& .MuiListItemIcon-root": { minWidth: "35px" },
                  "& .MuiListItemText-root": {
                    marginLeft: "0px",
                    display: isMobile ? "block" : open ? "block" : "none",
                  },
                  mb: open ? 0 : 2,
                }}
                component={RouterLink}
                to={item.path || ""}>
                <ListItemIcon className="menu_icon">
                  {item.icon}
                  {item.name === "share_animation" && cartCount > 0 && (
                    // !open &&  // Hide the badge when the sidebar is open
                    <span id="cart" className={isBouncing ? "flip" : ""}>
                      {cartCount}
                    </span>
                  )}
                </ListItemIcon>
                <ListItemText
                  className="menuText"
                  primary={t(item.name)}
                  sx={{
                    marginLeft: "5px",
                    visibility: isMobile
                      ? "visible"
                      : open
                        ? "visible"
                        : "hidden",
                  }}
                />
                {item.subItems &&
                  (isMobile || open) &&
                  (openMenus[item.name] ? (
                    <ExpandLessIcon className="menuText" />
                  ) : (
                    <ExpandMoreIcon className="menuText" />
                  ))}
              </ListItemButton>
            </Tooltip>
            {item.subItems && (
              <Collapse in={openMenus[item.name]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.subItems.map((subItem, subIndex) => (
                    <Tooltip
                      key={subIndex}
                      title={!open && !isMobile ? subItem.name : ""}
                      placement="right"
                      arrow>
                      <ListItemButton
                        key={subIndex}
                        onClick={(event) => {
                          if (subItem.path === "/loopvideo") {
                            event.preventDefault(); // Prevent default link behavior
                            window.open(subItem.path, "_blank"); // Open in new tab
                            if (isMobile) toggleSidebar();
                          } else {
                            handleMenuClick(item.name, subItem.name); // Set both parent & sub-item
                          }
                        }}
                        component={RouterLink}
                        to={subItem.path}
                        sx={{
                          pl: 6.5,
                          backgroundColor:
                            activeItem.subItem === subItem.name
                              ? "#1565c0"
                              : "transparent", // Highlight sub-item
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                          "& .MuiListItemText-root": {
                            display: isMobile
                              ? "block"
                              : open
                                ? "block"
                                : "none",
                          },
                        }}>
                        <ListItemText
                          className="menuText"
                          primary={t(subItem.name)}
                          sx={{
                            visibility: isMobile
                              ? "visible"
                              : open
                                ? "visible"
                                : "hidden",
                          }}
                        />
                      </ListItemButton>
                    </Tooltip>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}
      </List>
    </Drawer>
  );
};
export default Sidebar;
